﻿import { OpaccBrowser } from './vendor/script/classes/opacc.class.browser.js';
import { OpaccCookie } from './vendor/script/classes/opacc.class.cookie.js';
import { OpaccTag } from './sw.class.tag.js';

export const opaccBrowserPlugin = new OpaccBrowser();
export const opaccCookiePlugin = new OpaccCookie();
export const opaccTagPlugin = new OpaccTag();




